// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const CUSTOM_ISSUE_MAX_LENGTH = 30;

export const MAX_CUSTOM_ISSUES_PER_AREA = 6;
